export default __webpack_public_path__ + "static/media/unlink.f2ab5b2d.svg";